export const TransferDeviceToOrgModalReducer = (state, action) => {
	switch (action.type) {
		case "SET_STATIC_UI_ELEMENT":
			return {
				...state,
				staticUIElement: action.payload
			}
		case "TOGGLE_TRANSFER_DEVICE_TO_ORG_MODAL":
			return {
				...state,
				open: !state.open,
				selectedOrg: null,
				selectedDevice: null,
				isSuccess: false,
				isLoading: false,
				isError: false,
				errorMessage: null,
				isNotSelected: false
			}
		case "SET_DISABLED":
			return {
				...state,
				isDisabled: true
			}
		case "CANCEL_MOVE_DEVICE":
			return {
				...state,
				open: false,
				selectedOrg: null,
				selectedDevice: null,
				isSuccess: false,
				isLoading: false,
				isError: false,
				errorMessage: null,
				isNotSelected: false
			}
		case "SUCCESS_MOVE_DEVICE":
			return {
				...state,
				selectedOrg: null,
				selectedDevice: null,
				isSuccess: true,
				isLoading: false,
				isError: false,
				errorMessage: null,
				isNotSelected: false
			}
		case "SET_DATA":
			return {
				...state,
				data: action.payload
			}
		case "SET_SELECTED_ORG":
			return {
				...state,
				isNotSelected: false,
				selectedOrg: action.payload
			}
		case "SET_SELECTED_DEVICE":
			return {
				...state,
				isNotSelected: false,
				selectedDevice: action.payload
			}
		case "SET_LOADING_ORG":
			return {
				...state,
				isLoadingOrg: action.payload
			}
		case "SET_LOADING":
			return {
				...state,
				isLoading: action.payload
			}
		case "SET_ERROR":
			return {
				...state,
				isError: true,
				errorMessage: action.payload
			}
		case "SET_NOT_SELECTED":
			return {
				...state,
				isNotSelected: true
			}
		default:
			return state
	}
}
